/* AquaDream PDP interactions — vanilla JS, no dependencies */
(function () {
  if (window.__aquadreamInit) return;
  window.__aquadreamInit = true;

  function formatMoney(cents, format) {
    format = format || '${{amount}}';
    var value = (cents / 100);
    function withDelims(n, decimals, thousands, dec) {
      var parts = n.toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.join(decimals ? dec : '');
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, key) {
      switch (key) {
        case 'amount_no_decimals': return withDelims(value, 0, ',', '.');
        case 'amount_with_comma_separator': return withDelims(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelims(value, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return withDelims(value, 2, "'", '.');
        default: return withDelims(value, 2, ',', '.');
      }
    });
  }

  function initProduct(root) {
    var dataEl = root.querySelector('[data-ad-variants]');
    if (!dataEl) return;
    var data = JSON.parse(dataEl.textContent);
    var byId = {};
    data.variants.forEach(function (v) { byId[v.id] = v; });

    /* Gallery */
    var slides = root.querySelectorAll('[data-ad-slide]');
    var thumbs = root.querySelectorAll('[data-ad-thumb]');
    var cur = 0;
    function show(i) {
      if (!slides.length) return;
      cur = (i + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('is-active', k === cur); });
      thumbs.forEach(function (t, k) { t.setAttribute('aria-selected', k === cur ? 'true' : 'false'); });
      var t = thumbs[cur];
      if (t && t.scrollIntoView && window.matchMedia('(max-width: 899px)').matches) t.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    }
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { show(k); }); });
    var prev = root.querySelector('[data-ad-prev]'), next = root.querySelector('[data-ad-next]');
    if (prev) prev.addEventListener('click', function () { show(cur - 1); });
    if (next) next.addEventListener('click', function () { show(cur + 1); });
    var stage = root.querySelector('.ad-gallery__stage');
    if (stage) {
      var x0 = null;
      stage.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 40) show(cur + (dx < 0 ? 1 : -1));
        x0 = null;
      });
    }

    /* Bundles / variants */
    var input = root.querySelector('[data-ad-variant-input]');
    var priceEl = root.querySelector('[data-ad-price]');
    var compareEl = root.querySelector('[data-ad-compare]');
    var saveEl = root.querySelector('[data-ad-save]');
    var badgeEl = root.querySelector('[data-ad-badge]');
    var addBtn = root.querySelector('[data-ad-add]');
    var addLabel = root.querySelector('[data-ad-add-label]');
    var stockEl = root.querySelector('[data-ad-stock]');
    var stickyTitle = root.querySelector('[data-ad-sticky-title]');
    var stickyPrice = root.querySelector('[data-ad-sticky-price]');

    function applyVariant(v) {
      if (!v) return;
      input.value = v.id;
      var price = formatMoney(v.price, data.moneyFormat);
      priceEl.textContent = price;
      var hasCompare = v.compare > v.price;
      compareEl.hidden = !hasCompare;
      if (hasCompare) compareEl.textContent = formatMoney(v.compare, data.moneyFormat);
      var pct = hasCompare ? Math.floor((v.compare - v.price) * 100 / v.compare) : 0;
      if (saveEl) { saveEl.hidden = !pct; saveEl.textContent = 'SAVE ' + pct + '%'; }
      if (badgeEl) { badgeEl.hidden = !pct; badgeEl.textContent = pct + '% OFF'; }
      addBtn.disabled = !v.available;
      addLabel.textContent = v.available ? (data.atcLabel + ' · ' + price) : 'Sold out';
      if (stockEl) stockEl.textContent = v.available ? data.stockText : 'Sold out';
      if (stickyTitle) stickyTitle.textContent = data.productTitle + ' · ' + v.title;
      if (stickyPrice) stickyPrice.textContent = price + (data.stickyNote ? ' · ' + data.stickyNote : '');
      root.querySelectorAll('[data-ad-bundle]').forEach(function (l) {
        var r = l.querySelector('input');
        l.classList.toggle('is-checked', r && String(r.value) === String(v.id));
      });
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      } catch (e) {}
    }
    root.querySelectorAll('[data-ad-bundle] input').forEach(function (r) {
      r.addEventListener('change', function () { if (r.checked) applyVariant(byId[r.value]); });
    });

    /* Add to cart (progressive enhancement: without JS the form posts normally) */
    var form = root.querySelector('[data-ad-form]');
    var errEl = root.querySelector('[data-ad-error]');
    var after = root.getAttribute('data-after-add') || 'cart';
    var root_url = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (form && window.fetch) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (addBtn.disabled) return;
        addBtn.disabled = true;
        errEl.hidden = true;
        fetch(root_url + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(input.value), quantity: 1 }] })
        }).then(function (res) {
          return res.json().then(function (body) { return { ok: res.ok, body: body }; });
        }).then(function (r) {
          if (!r.ok) throw new Error((r.body && (r.body.description || r.body.message)) || 'Could not add to cart');
          document.dispatchEvent(new CustomEvent('aquadream:added', { detail: r.body }));
          if (after === 'checkout') window.location.href = root_url + 'checkout';
          else if (after === 'cart') window.location.href = root_url + 'cart';
          else {
            addBtn.disabled = false;
            fetch(root_url + 'cart.js').then(function (x) { return x.json(); }).then(function (cart) {
              document.querySelectorAll('.cart-count-bubble span[aria-hidden="true"], [data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
            }).catch(function () {});
          }
        }).catch(function (err) {
          addBtn.disabled = false;
          errEl.textContent = err.message;
          errEl.hidden = false;
        });
      });
    }

    /* Sticky mobile ATC */
    var sticky = root.querySelector('[data-ad-sticky]');
    if (sticky && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        var visible = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', visible);
        sticky.setAttribute('aria-hidden', visible ? 'false' : 'true');
        var b = sticky.querySelector('[data-ad-sticky-add]');
        if (b) b.tabIndex = visible ? 0 : -1;
      });
      io.observe(addBtn);
      var sb = sticky.querySelector('[data-ad-sticky-add]');
      if (sb) sb.addEventListener('click', function () {
        if (form.requestSubmit) form.requestSubmit(); else addBtn.click();
      });
    }
  }

  function initBA(el) {
    var range = el.querySelector('input[type=range]');
    if (!range) return;
    function set() { el.style.setProperty('--pos', range.value + '%'); }
    range.addEventListener('input', set);
    set();
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-ad-product]').forEach(function (r) { if (!r.__ad) { r.__ad = 1; initProduct(r); } });
    (scope || document).querySelectorAll('[data-ad-ba]').forEach(function (r) { if (!r.__ad) { r.__ad = 1; initBA(r); } });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  /* Theme editor support */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
